import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => [
  { label: 'S.N', value: 'id' },
  {
    label: 'Hub name',
    value: 'name1',
  },
  {
    label: 'Hub type',
    value: 'facilityType',
  },
  {
    label: 'env permit',
    value: 'envPermit',
  },
  {
    label: 'facility id',
    value: 'facilityPopupp',
  },

  {
    label: 'weight scale',
    // value: 'KYC',
    value: 'scannedImageUrl',
  },
  /*  {
    label: 'TAX',
    value: 'POI',
  },
  {
    label: 'ECC',
    value: 'POF',
  }, */
  /*   {
    label: 'ISO',
    value: 'isoCertificate',
  },
  {
    label: 'PPRS',
    value: 'pprsCertificate',
  }, */
  {
    label: 'certification',
    // value: 'facilityManager[name]',
    // value: 'weightscale_table',
    value: 'cerImg',
  },
  {
    label: 'status',
    // value: 'facilityManager[name]',
    value: 'status2',
  },
  /*   {
    action: ['id', 'view-table', 'edit'],
  }, */
  /*  {
    label: 'Joining Date',
    value: 'joinDate',
  },
  {
    label: 'Current Level',
    value: 'currentLevel',
  },
  {
    label: 'Points Earned',
    value: 'pointEarned',
  },
  {
    label: 'Redeemed',
    value: 'pointRedeemed',
  }, */
]

// const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)


const roleColumns = (isPartner = false, isSupplyChainManager = false, isFacilityManager) => {
  return columnGenerators(header(isPartner, isSupplyChainManager, isFacilityManager))
}

export { roleColumns }
